/**
 * @author Christine Movius
 * @desc multisite plans collection toggle component for global use
 * @example <multisite-plans-collection-toggle
 *               plans-collection="$ctrl.plansCollection"
 *               select-plans-collection="$ctrl.selectPlansCollection">
 *          </multisite-plans-collection-toggle>
*/

import template from './multisitePlansCollectionToggle.html';

const multisitePlansCollectionToggle = {
  template,
  bindings: {
    plansCollection: '<',
    selectPlansCollection: '&'
  }
};

export default function (ngModule) {
  ngModule.component('multisitePlansCollectionToggle', multisitePlansCollectionToggle);
}
